<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-md-12">
<!--				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>-->
<!--				<div class="card" v-if="asyncDone === false">-->
<!--					&lt;!&ndash; Show the loader when async operation is going on &ndash;&gt;-->
<!--					<div class="loader"></div>-->
<!--				</div>-->
        <h4 class="card-title text-center">Create New User</h4>
        <form class="form-horizontal" @submit.prevent="createUser">
          <div class="row">
            <label class="col-sm-2 col-form-label">Customer ID#
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-6">
              <div class="form-group">
                <input type="number" class="form-control" required v-model.trim="customer.id">
                <span class="form-text">Enter the customer's HostBill Customer ID.</span>
              </div>
            </div>
            <div class="col-sm-4">
              <a @click="fetchUserDtls" class="btn btn-warning mt-0 text-white" :disabled="!customer.id">Fetch User Details</a>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">First Name
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.firstName">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Name
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.lastName">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Company Name</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" v-model="customer.companyName">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">IP Address
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.ip">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 1
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.addrLine1">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 2</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" v-model="customer.addrLine2">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">City
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.city">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">State/Province
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.state">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Postal Code
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.postalCode">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Affiliate ID (if any)</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group">
                <input type="number" class="form-control" v-model="customer.affiliateID">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Name
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-10 col-md-2 col-lg-2">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.countryName">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Code
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-10 col-md-2 col-lg-2">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.countryCode">
              </div>
            </div>
            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Language
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-10 col-md-2 col-lg-2">
              <div class="form-group">
                <input type="text" class="form-control" required v-model="customer.language">
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">Email ID
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-10">
              <div class="form-group">
                <input type="email" class="form-control" v-model="customer.email">
              </div>
            </div>
          </div>
          <hr class="color-line" v-if="hostingAccounts.length > 0">
          <div class="loader small_loader" v-if="loadIP"></div>
          <!-- Section to show customer's Hosting Account details -->
          <div class="cust-acc-details" v-else v-for="(account, index) in hostingAccounts" :key="account.id">
            <button type="button" class="close text-red" aria-label="Close" @click.prevent="deleteItem(index, $event)">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="text-center">Account Details for: {{ account.domain }}</h5>
            <div class="row">
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Server IP</label>
              <div class="col-sm-10 col-md-2 col-lg-2">
                <div class="form-group">
                  <input type="text" class="form-control" :value="account.serverIP">
                </div>
              </div>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Primary Domain'">Plan Name
                  <strong class="text-danger">*</strong>
                </label>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Primary Domain'">
                  <div class="form-group">
                    <select class="form-control" v-model="account.name">
                      <option v-for="plan in plans" :value="plan.name" v-bind:key="plan.name"> {{ plan.name }}</option>
                    </select>
                  </div>
                </div>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Primary Domain'">Max Addon Domain Limit
                  <strong class="text-danger">*</strong>
                </label>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Primary Domain'">
                  <div class="form-group">
                    <input type="number" class="form-control" required v-model.number="account.maxAddonDomain">
                  </div>
                </div>
              </transition>
            </div>
            <div class="row">
              <!--									<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">-->
              <!--										<label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Addon Domain'">Primary Domain Name-->
              <!--											<strong class="text-danger">*</strong>-->
              <!--											<i class="fa fa-question-circle ml-2 text-dark" data-toggle="tooltip" data-placement="top" title="Make sure you enter the domain name EXACTLY as mentioned in the domain name section of the primary domain. Simply copy paste it to be sure."></i>-->
              <!--										</label>-->
              <!--									</transition>-->
              <!--									<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">-->
              <!--										<div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Addon Domain'">-->
              <!--											<div class="form-group">-->
              <!--												<input type="text" class="form-control" placeholder="primarydomain.com" required v-model="account.addonPrimaryDomain">-->
              <!--											</div>-->
              <!--										</div>-->
              <!--									</transition>-->
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Primary Domain'">Max Storage Size (GB)
                  <strong class="text-danger">*</strong>
                </label>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Primary Domain'">
                  <div class="form-group">
                    <input type="number" class="form-control" required v-model.number="account.maxStorageSize">
                  </div>
                </div>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Primary Domain'">Max Visitors
                  <strong class="text-danger">*</strong>
                </label>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Primary Domain'">
                  <div class="form-group">
                    <input type="number" class="form-control" required v-model.number="account.maxVisitors">
                  </div>
                </div>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Primary Domain'">Max Migrations
                  <strong class="text-danger">*</strong>
                </label>
              </transition>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <div class="col-sm-10 col-md-2 col-lg-2" v-if="account.type === 'Primary Domain'">
                  <div class="form-group">
                    <input type="number" class="form-control" required v-model.number="account.maxMigrations">
                  </div>
                </div>
              </transition>
            </div>
            <div class="row">
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                Hostbill Service ID
                <strong class="text-danger">*</strong>
              </label>
              <div class="col-sm-10 col-md-2 col-lg-2">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="account.hbServiceID">
                </div>
              </div>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                SolusVM VPS ID
                <strong class="text-danger">*</strong>
              </label>
              <div class="col-sm-10 col-md-2 col-lg-2">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="account.solusVM_VPS_ID">
                </div>
              </div>
              <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                Hostname
                <strong class="text-danger">*</strong>
              </label>
              <div class="col-sm-10 col-md-2 col-lg-2">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="account.hbHostname">
                </div>
              </div>

            </div>
            <hr class="color-line">
          </div>
          <!-- Section to show customer's Hosting Account details END -->
          <div class="row">
            <label class="col-sm-2 col-form-label"></label>
            <div class="form-check col-sm-10 ml-3">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="isSendEmail" /> Send Welcome Email?
                <span class="form-check-sign"></span>
              </label>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label"></label>
            <div class="col-sm-10">
              <div class="form-group">
                <button type="submit" class="btn btn-warning">Create User</button>
              </div>
            </div>
          </div>
        </form>
      </div>
		</div>
	</div>
</template>

<script>
	import {db, auth, functions} from "@/firebase/init";
	import _ from 'lodash';
	import randomstring from 'randomstring';
	import swal from 'sweetalert2';
  import { v4 as uuidv4 } from 'uuid';

  export default {
		name: "createNewUser",
		components: {
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue")
		},
		data() {
			return {
				loadIP: false,
				isSendEmail: false,
				customer: {
					id: null,
					firstName: null,
					lastName: null,
					companyName: null,
					ip: null,
					addrLine1: null,
					addrLine2: null,
					city: null,
					state: null,
					postalCode: null,
					affiliateID: null,
					countryName: null,
					countryCode: null,
					language: null,
					email: null,
					password: null
				},
				hostingAccounts: []
			};
		},
		computed: {
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			plans() {
				return this.$store.getters["plan/list"];
			}
		},
    watch: {
      customer: {
        immediate: true,
        deep: true,
        handler(value) {
          if (value.email) {
            this.customer.email = value.email.toLowerCase()
          }
        }
      }
    },
		mounted() {
			// localStorage.removeItem("customers");
			// localStorage.removeItem("accounts");
			// this.fetchUsers();
			// this.getAccounts();
		},
		methods: {
			fetchUserDtls() {
				// Start Async Operation
				this.$store.dispatch("async/stateUpdate", {state: false});

				// Now call the Firestore HTTP Cloud Function to get out details
				// const fetchHostBillData = functions.httpsCallable(
				// 	"fetchHostBillClientDetails"
				// );
				// fetchHostBillData({
				// 	clientID: this.customer.id
				// })
        this.$http.post('host-bill/fetch-hostbill-client-details', {
          grant_type: 'token',
          clientId: this.customer.id,
        })
					.then(async response => {
						// Check if the response hold any error message then show the error message
						if (response.data.message) {
							// Set the all data in the customer object and hostingAccounts array to null
							for (let key in this.customer) {
								if (key !== "id") {
									this.customer[key] = null;
								}
							}

							// Set hostingAccounts array to a blank array
							this.hostingAccounts = [];

							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true});

							// Shoe the error message to the admin for 8 sec
							this.$store.dispatch("alert/update", {
								type: "danger",
								message: response.data.message,
								show: true
							});

							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 8000);
						} else {
							this.customer.firstName = response.data.custDetails.firstname;
							this.customer.lastName = response.data.custDetails.lastname;
							this.customer.companyName = response.data.custDetails.companyname;
							this.customer.ip = response.data.custDetails.ip;
							this.customer.addrLine1 = response.data.custDetails.address1;
							this.customer.addrLine2 = response.data.custDetails.address2;
							this.customer.city = response.data.custDetails.city;
							this.customer.state = response.data.custDetails.state;
							this.customer.postalCode = response.data.custDetails.postcode;
							this.customer.affiliateID = response.data.custDetails.affiliate_id;
							this.customer.countryName = response.data.custDetails.countryname;
							this.customer.countryCode = response.data.custDetails.country;
							// As the language name comes in all small letters, we are converting the firest letter to upper case
							this.customer.language =
								response.data.custDetails.language.charAt(0).toUpperCase() +
								response.data.custDetails.language.slice(1);
							this.customer.email = response.data.custDetails.email;

							// Get the Hosting Account details for the customer
							this.hostingAccounts = [];
							for(const acc of response.data.custAccounts){
								this.loadIP = true;
								let ipAddress = 'N/A';
								let hddInfo = 'N/A';
								try{
									const nodeInfoResp = await this.$http.post('/solus-vm/fetch_node_info', {
										vmId: acc.extra_details.option6,
										grant_type: 'token'
									});
									if(nodeInfoResp.data.status === 'success') {
										ipAddress = nodeInfoResp.data.ipaddresses;
										const hddList = nodeInfoResp.data.hdd.split(',');
										hddInfo = {
											total: hddList[0],
											used: hddList[1],
											free:hddList[2],
											usedPercent: hddList[3]
										}
									}else {
										ipAddress = nodeInfoResp.data.message
									}
								}catch (e) {
									console.error(e);
								}
								this.loadIP = false;
								acc.hddInfo = hddInfo;
								acc.status = "pending";
								acc.type = "Primary Domain";
								acc.serverIP = ipAddress;
								acc.maxAddonDomain = this.maxAddonDomainCountGenerator(acc.name);
								acc.maxStorageSize = this.diskSpaceGenerator(acc.name);
								acc.maxVisitors = this.visitorsGenerator(acc.name);
								acc.maxMigrations = this.maxMigrationCountGenerator(acc.name);
								acc.hbServiceID = acc.id;
								acc.hbHostname = acc.domain;
								acc.solusVM_VPS_ID = acc.extra_details.option6;
								this.hostingAccounts.push(acc);
							}
							// response.data.custAccounts.forEach(async (acc) => {
							//
							// });

							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true});
						}
					})
					.catch(err => {
						// console.log(err);
						// Set asyncDone to true
						this.$store.dispatch("async/stateUpdate", {state: true});

						// Shoe the error message to the admin for 8 sec
						this.$store.dispatch("alert/update", {
							type: "danger",
							message: err.data.message,
							show: true
						});

						setTimeout(() => {
							this.$store.dispatch("alert/showUpdate", {show: false});
						}, 8000);
					});
			},
			maxMigrationCountGenerator(planName) {
				let plan = this.plans.filter((item) => item.name == planName);
				if (plan.length) {
					return plan[0].maxMigrations;
				}
				return 0;
			},
			maxAddonDomainCountGenerator(planName) {
				let plan = this.plans.filter((item) => item.name == planName);
				if (plan.length) {
					return plan[0].maxAddonDomain;
				}
				return 1;
			},
			diskSpaceGenerator(planName) {
				let plan = this.plans.filter((item) => item.name == planName);
				if (plan.length) {
					return plan[0].maxStorageSize;
				}
				return 10;
			},
			visitorsGenerator(planName) {
				let plan = this.plans.filter((item) => item.name == planName);
				if (plan.length) {
					return plan[0].visitors;
				}
				return 250000;
			},
			deleteItem(index) {
				if (confirm("Are you sure about deleting this item?")) {
					this.hostingAccounts = this.hostingAccounts.filter(
						(acc, currentIndex) => {
							if (currentIndex !== index) {
								return true;
							}
						}
					);
				}
			},
			clearAddonPrimaryDomain(accType, currentIndex) {
				if (accType === "Primary Domain") {
					this.hostingAccounts[currentIndex].addonPrimaryDomain = null;
				}
			},
			checkUndefined(data) {
				if (typeof data === "undefined" || data === null) {
					return "";
				} else {
					return data;
				}
			},
			async createUser() {
				// Check if all the required fields have entered correctly or they are null
				// If they are null then throw error
				this.customer.password = randomstring.generate(16);
				const userRef = await db.collection('users').where('email', '==', this.customer.email.toLowerCase()).get();
				if(userRef.size > 0) {
          this.addLog({
            message: `${this.customer.email} already exists in the WPO!`,
            level: "danger"
          })
					return swal('Already Exist!',`${this.customer.email} already exists in the WPO!`, 'error');
				}
				if (
					this.customer.id &&
					this.customer.firstName &&
					this.customer.lastName &&
					this.customer.ip &&
					this.customer.addrLine1 &&
					this.customer.city &&
					this.customer.state &&
					this.customer.postalCode &&
					this.customer.countryName &&
					this.customer.countryCode &&
					this.customer.language &&
					this.customer.email &&
					this.customer.password
				) {

          if (this.hostingAccounts.length > 0) {
            // Set asyncDone to false
            this.$store.dispatch("async/stateUpdate", {state: false});

            let accountFiltered = [];
            // Filter the account array inside customers object to only add the primary domains
            this.hostingAccounts.forEach(async account => {
              if (account.type === "Primary Domain") {
                accountFiltered.push({
                  planName: account.name,
                  migration: {
                    count: 0,
                    log: []
                  },
                  primary: {
                    hbServiceID: this.checkUndefined(account.hbServiceID),
                    solusVM_VPS_ID: this.checkUndefined(account.solusVM_VPS_ID),
                    hbHostname: this.checkUndefined(account.hbHostname),
                    domain: '',
                    serverIP: this.checkUndefined(account.serverIP),
                    status: account.status,
                    comparisonID: this.checkUndefined(account.comparisonID),
                    flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
                    freashInstall: false,
                    hdd: account.hddInfo,
                    ftp: {
                      host: this.checkUndefined(account.ftpHost),
                      port: this.checkUndefined(account.ftpPort),
                      mode: this.checkUndefined(account.ftpMode),
                      pasv: this.checkUndefined(account.ftpPasv),
                      username: this.checkUndefined(account.ftpUsername),
                      password: this.checkUndefined(account.ftpPassword),
                      accounts: [
                        {
                          username: this.checkUndefined(account.ftpUsername),
                          password: this.checkUndefined(account.ftpPassword),
                        }
                      ]
                    },
                    phpMyAdmin: {
                      url: this.checkUndefined(account.phpMyAdminURL),
                      popupUsername: this.checkUndefined(
                          account.phpMyAdminPopupUsername
                      ),
                      popupPassword: this.checkUndefined(
                          account.phpMyAdminPopupPassword
                      ),
                      username: this.checkUndefined(account.phpMyAdminUsername),
                      password: this.checkUndefined(account.phpMyAdminPassword)
                    },
                    cloudflare: {
                      username: this.checkUndefined(account.cloudflareUsername),
                      password: this.checkUndefined(account.cloudflarePassword),
                      userKey: this.checkUndefined(account.cloudflareUserKey),
                      apiKey: this.checkUndefined(account.cloudflareApiKey),
                      zone_id: this.checkUndefined(account.cloudflareZoneId),
                      nameserver1: this.checkUndefined(
                          account.cloudflareNameserver1
                      ),
                      nameserver2: this.checkUndefined(
                          account.cloudflareNameserver2
                      )
                    },
                    staging: {
                      enabled: false,
                      domain: "",
                      flushOpcacheURL: "",
                      freashInstall: false,
                      ftp: {
                        host: "",
                        port: "21",
                        mode: "FTP (explicit SSL)",
                        pasv: "Ensure is Checked/Enabled",
                        username: "",
                        password: "",
                        accounts: [
                          {
                            username: "",
                            password: "",
                          }
                        ]
                      },
                      phpMyAdmin: {
                        url: "",
                        popupUsername: "",
                        popupPassword: "",
                        username: "",
                        password: ""
                      }
                    }
                  },
                  maxAddonDomain: account.maxAddonDomain,
                  maxStorageSize: account.maxStorageSize,
                  maxVisitors: account.maxVisitors,
                  maxMigrations: account.maxMigrations,
                  addon: []
                });
              }
            });
            // Filter the hosting accounts array again to add the addon domain under the specific primary domain
            this.hostingAccounts.forEach(account => {
              if (account.type === "Addon Domain") {
                const primaryDomainIndex = accountFiltered.findIndex(acc => {
                  return acc.primary.domain === account.addonPrimaryDomain;
                });
                accountFiltered[primaryDomainIndex].addon.push({
                  domain: account.domain,
                  chargable: false,
                  serverIP: this.checkUndefined(account.serverIP),
                  status: account.status,
                  comparisonID: this.checkUndefined(account.comparisonID),
                  flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
                  freashInstall: false,
                  ftp: {
                    host: this.checkUndefined(account.ftpHost),
                    port: this.checkUndefined(account.ftpPort),
                    mode: this.checkUndefined(account.ftpMode),
                    pasv: this.checkUndefined(account.ftpPasv),
                    username: this.checkUndefined(account.ftpUsername),
                    password: this.checkUndefined(account.ftpPassword),
                    accounts: [
                      {
                        username: this.checkUndefined(account.ftpUsername),
                        password: this.checkUndefined(account.ftpPassword),
                      }
                    ]
                  },
                  phpMyAdmin: {
                    url: this.checkUndefined(account.phpMyAdminURL),
                    popupUsername: this.checkUndefined(
                        account.phpMyAdminPopupUsername
                    ),
                    popupPassword: this.checkUndefined(
                        account.phpMyAdminPopupPassword
                    ),
                    username: this.checkUndefined(account.phpMyAdminUsername),
                    password: this.checkUndefined(account.phpMyAdminPassword)
                  },
                  cloudflare: {
                    username: this.checkUndefined(account.cloudflareUsername),
                    password: this.checkUndefined(account.cloudflarePassword),
                    userKey: this.checkUndefined(account.cloudflareUserKey),
                    apiKey: this.checkUndefined(account.cloudflareApiKey),
                    zone_id: this.checkUndefined(account.cloudflareZoneId),
                    nameserver1: this.checkUndefined(account.cloudflareNameserver1),
                    nameserver2: this.checkUndefined(account.cloudflareNameserver2)
                  },
                  staging: {
                    enabled: false,
                    domain: "",
                    flushOpcacheURL: "",
                    freashInstall: false,
                    ftp: {
                      host: "",
                      port: "21",
                      mode: "FTP (explicit SSL)",
                      pasv: "Ensure is Checked/Enabled",
                      username: "",
                      password: "",
                      account: [
                        {
                          username: "",
                          password: "",
                        }
                      ]
                    },
                    phpMyAdmin: {
                      url: "",
                      popupUsername: "",
                      popupPassword: "",
                      username: "",
                      password: ""
                    }
                  }
                });
              }
            });
            // console.log(accountFiltered);

            // Connect with firebase auth server to create the user account and then connect to firebase Firestore to store the user data
            this.$http.post('auth/create-new-user', {
              grant_type: 'token',
              email: this.customer.email,
              password: this.customer.password
            })
                .then(response => {
                  const credential = response.data;
                  // User Created
                  // Store the extra data about the user in Firebase Firestore database's user collection
                  // Store the accounts details in the account collection
                  db
                      .collection("users")
                      .doc(credential.user.uid)
                      .set({
                        uuid: uuidv4(),
                        userType: "normal",
                        customerID: this.customer.id,
                        firstName: this.customer.firstName,
                        lastName: this.customer.lastName,
                        companyName: this.customer.companyName,
                        ip: this.customer.ip,
                        addrLine1: this.customer.addrLine1,
                        addrLine2: this.customer.addrLine2,
                        city: this.customer.city,
                        state: this.customer.state,
                        postalCode: this.customer.postalCode,
                        affiliateID: this.customer.affiliateID,
                        countryName: this.customer.countryName,
                        countryCode: this.customer.countryCode,
                        language: this.customer.language,
                        email: this.customer.email.toLowerCase(),
                        createdAt: Date.now(),
                        updatedAt: Date.now()
                      })
                      .then(() => {
                        db
                            .collection("hostingAccounts")
                            .doc(credential.user.uid)
                            .set({
                              accounts: accountFiltered,
                              updatedAt: new Date().toISOString()
                            })
                            .then(async () => {

                              // localStorage.removeItem("customers");
                              await this.addLog({
                                message: `New user account has been created. Email: ${this.customer.email}`,
                                level: "info"
                              })
                              if(this.isSendEmail) {
                                await this.$http.post('/utilities/send-welcome-email', {
                                  grant_type: 'token',
                                  userEmail: this.customer.email,
                                  fullName: this.customer.firstName + ' ' + this.customer.lastName,
                                  UID: credential.user.uid
                                })
                              }
                              for (const account of this.hostingAccounts) {
                                await this.$http.post('/algolia/add-new-record', {
                                  grant_type: 'token',
                                  uid : credential.user.uid,
                                  customerID : this.customer.id || '',
                                  email : this.customer.email || '',
                                  firstName : this.customer.firstName || '',
                                  lastName : this.customer.lastName || '',
                                  domain: '',
                                  serverIP: account.serverIP
                                })
                              }
                              localStorage.removeItem("accounts");

                              this.fetchUsers();
                              // this.getAccounts();


                              // Set asyncDone to true
                              this.$store.dispatch("async/stateUpdate", {state: true});

                              // Show the success message to the admin for 5 seconds
                              this.$store.dispatch("alert/update", {
                                type: "success",
                                message: `The user account for ${
                                    this.customer.firstName
                                } ${this.customer.lastName} (${
                                    this.customer.email
                                }) has been created successfully.`,
                                show: true
                              });

                              swal({
                                title: 'User Created',
                                html: 'User has been successfully created in WPO. The password for this user is: <b>' + this.customer.password + '</b>',
                                type: 'success'
                              });

                              // Clear all the data after user created
                              for (let key in this.customer) {
                                this.customer[key] = null;
                              }
                              this.hostingAccounts = [];

                              setTimeout(() => {
                                this.$store.dispatch("alert/showUpdate", {show: false});
                                this.$router.push({ name: 'editUser', params: { docID: credential.user.uid } });
                              }, 5000);
                            })
                            .catch(err => {
                              // Set asyncDone to true
                              this.$store.dispatch("async/stateUpdate", {state: true});

                              // Show the success message to the admin for 5 seconds
                              this.$store.dispatch("alert/update", {
                                type: "danger",
                                message: err.message,
                                show: true
                              });
                              this.addLog({
                                message: err.message,
                                level: "danger"
                              })
                              setTimeout(() => {
                                this.$store.dispatch("alert/showUpdate", {show: false});
                              }, 5000);
                            });
                      })
                      .catch(err => {
                        // Set asyncDone to true
                        this.$store.dispatch("async/stateUpdate", {state: true});

                        // Show the success message to the admin for 5 seconds
                        this.$store.dispatch("alert/update", {
                          type: "danger",
                          message: err.message,
                          show: true
                        });
                        this.addLog({
                          message: err.message,
                          level: "danger"
                        })
                        setTimeout(() => {
                          this.$store.dispatch("alert/showUpdate", {show: false});
                        }, 5000);
                      });
                })
                .catch(err => {
                  // Set asyncDone to true
                  this.$store.dispatch("async/stateUpdate", {state: true});

                  // Show the success message to the admin for 5 seconds
                  this.$store.dispatch("alert/update", {
                    type: "danger",
                    message: err.message,
                    show: true
                  });
                  this.addLog({
                    message: err.message,
                    level: "danger"
                  })
                  setTimeout(() => {
                    this.$store.dispatch("alert/showUpdate", {show: false});
                  }, 5000);
                });
          } else {
            // Show the success message to the admin for 5 seconds
            this.$store.dispatch("alert/update", {
              type: "danger",
              message:
                  "No service found for this customer on HB. Please ensure you have entered valid customer ID.",
              show: true
            });
            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", {show: false});
            }, 5000);
          }
				} else {
					// Show the success message to the admin for 5 seconds
					this.$store.dispatch("alert/update", {
						type: "danger",
						message:
							"Please ensure all the required fields have been entered and not blank",
						show: true
					});
          this.addLog({
            message: `Please ensure all the required fields have been entered and not blank`,
            level: "danger"
          })
					setTimeout(() => {
						this.$store.dispatch("alert/showUpdate", {show: false});
					}, 5000);
				}
			},
			fetchUsers() {
				// db
				// 	.collection("users")
				// 	.where("userType", "==", "normal")
				// 	.orderBy("createdAt", "desc")
				// 	.get()
				// 	.then(snapshot => {
				// 		if (snapshot.empty !== true) {
				// 			this.customers = [];
				// 			snapshot.forEach(doc => {
				// 				this.customers.push({
				// 					docID: doc.id,
				// 					...doc.data()
				// 				});
				// 			});
				// 			localStorage.setItem("customers", JSON.stringify(this.customers));
				// 		}
				// 	})
				// 	.catch(err => {
				// 		console.log(err);
				// 	});
			},
			// getAccounts() {
			// 	db
			// 			.collection("hostingAccounts")
			// 			.get()
			// 			.then(snapshot => {
			// 				this.accounts = [];
			// 				snapshot.forEach(doc => {
			// 					const accountData = doc.data();
			// 					let accountToBeAdded = [];
			// 					_.map(accountData.accounts, (item) => {
			// 						let dataToBeAdded = {
			// 							primary: {
			// 								domain: item.primary.domain,
			// 								status: item.primary.status,
			// 								cloudflare: item.primary.cloudflare
			// 							},
			// 							addon: []
			// 						};
			// 						_.map(item.addon, (addon) => {
			// 							dataToBeAdded.addon.push({domain: addon.domain, status: addon.status})
			// 						});
			// 						accountToBeAdded.push(dataToBeAdded);
			// 					});
			// 					this.accounts.push({docID: doc.id, accounts: accountToBeAdded});
			// 				});
			// 				localStorage.setItem("accounts", JSON.stringify(this.accounts));
			// 			})
			// 			.catch(err => {
			// 				console.log(err);
			// 			});
			// },
		},
		updated() {
			/* eslint-disable */
			$(function () {
				$('[data-toggle="tooltip"]').tooltip();
			});
			/* eslint-enable */
		}
	};
</script>
